import { _ } from './../utils.js'
export default (el) => {
    const button = _('button', 'element').nodeFrom(el)
    const input = _('input', 'element').nodeFrom(el)

    const toggleButton = (e) => {
        if (e.currentTarget.value.length > 0) {
            button.classList.add('button--active')
        } else {
            button.classList.remove('button--active')
        }
    }

    input.addEventListener('keyup', toggleButton)
}
